import type { AppLayoutState } from './app-layout.hook'
import type { SidebarNavGroup } from './sidebar-nav-item.interface'
import type { UseAppLayoutActionsReturn } from './use-app-layout-actions.hook'
import type { UseAppLayoutOrganizationReturn } from './use-app-layout-organization.hook'
import type { UseAppLayoutSearchReturn } from './use-app-layout-search.hook'

interface BuildAppLayoutStateParams {
  search: UseAppLayoutSearchReturn
  organization: UseAppLayoutOrganizationReturn
  actions: UseAppLayoutActionsReturn
  navGroups: SidebarNavGroup[]
}

export const buildAppLayoutState = ({
  search,
  organization,
  actions,
  navGroups,
}: BuildAppLayoutStateParams): AppLayoutState => ({
  searchQuery: search.state.searchQuery,
  searchResultGroupList: search.state.searchResultGroupList,
  isSearching: search.state.isSearching,
  navGroups,
  organizations: organization.state.organizations,
  userData: organization.state.userData,
  activeOrgData: organization.state.activeOrgData,
  subscriptionInfo: organization.state.subscriptionInfo,
  createOrgDialog: organization.state.createOrgDialog,
  chatDeleteDialog: actions.state.chatDeleteDialog,
})
